let googleMapsPromise: Promise<void> | null = null

const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script'

const getApiKey = () => import.meta.env.VITE_GOOGLE_PLACES_API_KEY || import.meta.env.VITE_GOOGLE_MAPS_API_KEY

export const loadGoogleMapsPlaces = (): Promise<void> => {
    if (window.google?.maps?.places) {
        return Promise.resolve()
    }

    if (googleMapsPromise) {
        return googleMapsPromise
    }

    const apiKey = getApiKey()

    googleMapsPromise = new Promise<void>((resolve, reject) => {
        if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
            const existingScript = document.getElementById(GOOGLE_MAPS_SCRIPT_ID) as HTMLScriptElement
            existingScript.addEventListener('load', () => resolve())
            existingScript.addEventListener('error', () => reject(new Error('Error loading Google Maps script')))
            return
        }

        if (!apiKey) {
            console.warn('Google Places API key is not configured; autocomplete will be disabled.')
            resolve()
            return
        }

        const script = document.createElement('script')
        script.id = GOOGLE_MAPS_SCRIPT_ID
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`
        script.async = true
        script.defer = true

        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Error loading Google Maps script'))

        document.head.appendChild(script)
    })

    return googleMapsPromise
}


